import { CommonModule, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import Swal from 'sweetalert2';

import { FlyingbeesService } from '../flyingbees.service';
import { BeesHeaderComponent } from '../bees-header/bees-header.component';
import { BeesFooterComponent } from '../bees-footer/bees-footer.component';

@Component({
  selector: 'app-page-contact',
  standalone: true,
  imports: [
    BeesHeaderComponent,
    BeesFooterComponent,
    RouterLink,
    NgIf,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './page-contact.component.html',
  styleUrls: ['./page-contact.component.scss']
})
export class PageContactComponent implements OnInit {

  ContactFrm!: FormGroup;

  mobileMenuOpen = false;
  showRegister = false;

  constructor(
    private manas: FlyingbeesService,
    private router: Router
  ) { }

  ngOnInit(): void {

    this.ContactFrm = new FormGroup({

      name: new FormControl('', [
        Validators.required
      ]),

      email: new FormControl('', [
        Validators.required,
        Validators.email
      ]),

      phone_number: new FormControl('', [
        Validators.required,
        Validators.pattern('^[0-9]{10}$')
      ]),

      message: new FormControl('')
    });

  }

  toggleMobileMenu(): void {

    this.mobileMenuOpen = !this.mobileMenuOpen;

    const mobileMenu =
      document.querySelector('.mobile-nav__wrapper');

    if (mobileMenu) {

      if (this.mobileMenuOpen) {
        mobileMenu.classList.add('expanded');
      } else {
        mobileMenu.classList.remove('expanded');
      }

    }
  }

  closeModal(): void {
    this.showRegister = false;
  }

  feedback(): void {

    if (this.ContactFrm.invalid) {

      this.ContactFrm.markAllAsTouched();

      Swal.fire({
        title: 'Validation Error',
        text: 'Please fill all required fields correctly.',
        icon: 'warning'
      });

      return;
    }

    this.showRegister = false;

    this.manas.ContactFrm(
      this.ContactFrm.value.name,
      this.ContactFrm.value.email,
      this.ContactFrm.value.phone_number,
      this.ContactFrm.value.message
    )
    .subscribe({

      next: (res: any) => {

        console.log(res);

        if (res.status === 'success') {

          this.ContactFrm.reset();

          Swal.fire({
            title: 'Success',
            text: 'Your enquiry has been submitted successfully.',
            icon: 'success',
            confirmButtonText: 'OK'
          });

        }
        else {

          Swal.fire({
            title: 'Error',
            text: res.message || 'Something went wrong.',
            icon: 'error'
          });

        }

      },

      error: (err) => {

        console.error(err);

        Swal.fire({
          title: 'Server Error',
          text: 'Please try again later.',
          icon: 'error'
        });

      }

    });

  }

}